import React, { useEffect } from "react";
import { Form, message } from "antd";
import { useParams } from "react-router-dom";
import { AuthContainer } from "../../styles/LoginSignUp/authContainer";
import api from '../../services/api';

export const AuthorizeAccountant: React.FC = () => {
  const { token } = useParams();

  useEffect(() => {
    api.post(`/clients/authorize-accountant/${token}`).then(() => {
      message.success('Usuário autorizado com sucesso', 5);
    }).catch((err: any) => {
      if(err?.response?.status === 400) {
        message.error(err.response?.data?.message || 'Ocorreu um erro')
      }

      return;
    })
  }, [token]);

  return (
    <AuthContainer className="beauty-scrollbar">
      <div className="auth-content">
        <div className="form-container">
          <h1>Autorização de usuário</h1>
          <Form
            size="large"
          >
          </Form>
        </div>
      </div>
    </AuthContainer>
  );
};
